import React, { Component } from 'react';

const TrainingInfo = () => {
	return ( <h1>PSSFWeb Training Info</h1> );
}
 
export default TrainingInfo;